import { LogoProps } from './Logo.types'
import React from 'react'

const BalloonLogo = ({ width = 76, height = 82, ...props }: LogoProps) => {
    const basePath = process.env.NEXT_PUBLIC_BASE_PATH || ''

    return (
        <img {...props} width={width} height={height} src={`${basePath}/REMAX-Balloon-RGB.png`} alt='RE/MAX Balloon' />
    )
}

export default BalloonLogo
